"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Empty = function Empty() {
  return null;
};
var _default = Empty;
exports.default = _default;